import {
  CompositeContextProvider,
  CompositeScopedContextProvider
} from "./5C7J4IAS.js";
import {
  createStoreContext
} from "./CFEUKV6C.js";

// src/radio/radio-context.tsx
var ctx = createStoreContext(
  [CompositeContextProvider],
  [CompositeScopedContextProvider]
);
var useRadioContext = ctx.useContext;
var useRadioScopedContext = ctx.useScopedContext;
var useRadioProviderContext = ctx.useProviderContext;
var RadioContextProvider = ctx.ContextProvider;
var RadioScopedContextProvider = ctx.ScopedContextProvider;

export {
  useRadioContext,
  useRadioScopedContext,
  useRadioProviderContext,
  RadioContextProvider,
  RadioScopedContextProvider
};
